import { jsx as _jsx } from "react/jsx-runtime";
import Text from "./Text";
import { applyPropertyControls, ControlType } from "../../property-controls";
import { contentBoxPropertyControls } from "../../ContentBox";
import { FormattedMessage } from "react-intl";
applyPropertyControls(Text, {
    text: {
        type: ControlType.String,
        title: (_jsx(FormattedMessage, { id: "dploy.grid.text.text.label", defaultMessage: "Text" })),
        multiline: true,
        description: (_jsx(FormattedMessage, { id: "dploy.grid.text.text.description", defaultMessage: "Supports markdown formatting" })),
        coerce: (_, values) => values.content
    },
    boxProps: contentBoxPropertyControls
});
export default Text;
//# sourceMappingURL=property-controls.js.map